<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">
        Rapport
      </p>
    </header>
    <div class="card-content">
      <section>
        <p>
          Waardering van de vakken in groep 6 en 7 de cijfers v/d overgangsrapporten vermelden groep 8 het eerste rapport
        </p>
        <br>
        <b-table :data="marksData" :bordered="true" :narrowed="true" :striped="false" :loading="loading" :paginated="isPaginated" :per-page="perPage" :current-page.sync="currentPage" :pagination-simple="isPaginationSimple" :default-sort-direction="defaultSortDirection">
          <template slot-scope="props">
            <b-table-column width="375" label="Taal geletterdheid en communicatie">
              <div class="columns">
                <div class="column is-8">
                  <template v-if="props.row.usersequence == 1">
                    <b>{{props.row.tbl_sys_subject_type.name}}</b>
                  </template>
                </div>
                <div class="column">
                  <span>{{props.row.name}}</span>
                </div>
              </div>

            </b-table-column>
            <b-table-column label="6" width="25">

              <b-input @keyup.up="alert('keyuup');" v-model="marks_six[props.row.id-1]" @change="checkvalues(marks_seven[props.row.id-1])" @blur="update_six({sys_subject_id:props.row.id,grade_id:1})">
              </b-input>

            </b-table-column>
            <b-table-column label="7" width="25">

              <b-input v-model="marks_seven[props.row.id-1]" @change="checkvalues(marks_seven[props.row.id-1])" @blur="update_seven({sys_subject_id:props.row.id,grade_id:2})">
              </b-input>

            </b-table-column>
            <b-table-column label="8:1" width="25">

              <b-input v-model="marks_eight[props.row.id-1]" @change="checkvalues(marks_seven[props.row.id-1])" @blur="update_eigth({sys_subject_id:props.row.id,grade_id:3})">
              </b-input>

            </b-table-column>
          </template>
        </b-table>

      </section>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import { API_ROOT } from "../../config";

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 600000
});

console.log(API_ROOT);
export default {
  name: "subjectmarks",
  props: ["studentid"],
  data: function() {
    return {
      marksData: [
        {
          id: 1,
          subject_type_id: 1,
          grade_id: 1,
          name: "",
          usersequence: 1,
          tbl_sys_subject_type: {
            id: 1,
            name: ""
          }
        }
      ],
      marks_six: [],
      marks_seven: [],
      marks_eight: [],
      loading: false,
      isEmpty: false,
      isPaginated: false,
      isPaginationSimple: false,
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 12
    };
  },
  created() {
    // fetch the data when the view is created and the data is
    // already being observed

    this.fetch_data();
  },
  methods: {
    fetch_data() {
      var self = this;

      console.log("Building Rapport ...");
      instance.get("/subjects").then(function(response) {
        var subjects = response.data.data;
        _.merge(self.marksData, response.data.data);

        for (var i = 0; i < subjects.length; i++) {
          self.marks_six.push("");
          self.marks_seven.push("");
          self.marks_eight.push("");
        }

        self.loading = true;

        //TODO:populate marks from database

        instance
          .get("/student-mark-student", {
            params: {
              student_id: self.$route.params.id,
              grade_id: 1
            }
          })
          .then(function(response) {
            var marks = response.data.data;
            console.log(marks);
            for (var i = 0; i < marks.length; i++) {
              if (marks[i].mark != 0) {
                self.$set(
                  self.marks_six,
                  marks[i].sys_subject_id - 1,
                  marks[i].mark
                );
              } else {
                self.$set(self.marks_six, marks[i].sys_subject_id - 1, "");
              }
            }
          });

        instance
          .get("/student-mark-student", {
            params: {
              student_id: self.$route.params.id,
              grade_id: 2
            }
          })
          .then(function(response) {
            var marks = response.data.data;
            for (var i = 0; i < marks.length; i++) {
              if (marks[i].mark != 0) {
                self.$set(
                  self.marks_seven,
                  marks[i].sys_subject_id - 1,
                  marks[i].mark
                );
              } else {
                self.$set(self.marks_seven, marks[i].sys_subject_id - 1, "");
              }
            }
          });

        instance
          .get("/student-mark-student", {
            params: {
              student_id: self.$route.params.id,
              grade_id: 3
            }
          })
          .then(function(response) {
            var marks = response.data.data;
            console.log(marks);
            for (var i = 0; i < marks.length; i++) {
              if (marks[i].mark != 0) {
                self.$set(
                  self.marks_eight,
                  marks[i].sys_subject_id - 1,
                  marks[i].mark
                );
              } else {
                self.$set(self.marks_eight, marks[i].sys_subject_id - 1, "");
              }
            }

            self.loading = false;
          });

        self.$store.dispatch("load", {
          name: "rapport",
          value: false
        });
      });
    },
    checkvalues(value) {
      console.log(value);
      console.log(_.isNumber(value));
    },
    update_six(obj) {
      //first delete all disabilities the nsave new list
      console.log("Update Rapport 6");
      console.log(obj);
      console.log(this.marks_six[obj.sys_subject_id - 1]);
      console.log(this.marks_six);

      var self = this;

      instance
        .post("/student-mark-update", {
          student_id: this.studentid,
          grade_id: obj.grade_id,
          sys_subject_id: obj.sys_subject_id,
          mark: (self.marks_six[obj.sys_subject_id - 1] == '' ? 0 : self.marks_six[obj.sys_subject_id - 1])
        })
        .then(function(response) {
          //console.log(response.data.data);
        });
    },
    update_seven(obj) {
      //first delete all disabilities the nsave new list
      console.log("Update Rapport 7");
      console.log(obj);
      console.log(this.marks_seven[obj.sys_subject_id - 1]);
      console.log(this.marks_seven);

      var self = this;

      //sys_subject_id:scope.row.id,grade_id:1}

      instance
        .post("/student-mark-update", {
          student_id: this.studentid,
          grade_id: obj.grade_id,
          sys_subject_id: obj.sys_subject_id,
          mark:  (self.marks_seven[obj.sys_subject_id - 1] == '' ? 0 : self.marks_seven[obj.sys_subject_id - 1])
        })
        .then(function(response) {
          //console.log(response.data.data);
        });
    },
    update_eigth(obj) {
      //first delete all disabilities the nsave new list
      console.log("Update Rapport 8");
      console.log(obj);
      console.log(this.marks_eight[obj.sys_subject_id - 1]);
      console.log(this.marks_eight);

      var self = this;

      instance
        .post("/student-mark-update", {
          student_id: this.studentid,
          grade_id: obj.grade_id,
          sys_subject_id: obj.sys_subject_id,
          mark: (self.marks_eight[obj.sys_subject_id - 1] == '' ? 0 : self.marks_eight[obj.sys_subject_id - 1])
        })
        .then(function(response) {
          //console.log(response.data.data);
        });
    }
  }
};
</script>
<style scoped>
.okrhead {
  font-size: 20px;
  font-weight: bold;
}

.okritem {
  margin-bottom: 5px;
}
</style>
